import React from "react"
import { useTranslation } from "react-i18next"
import { Box, Typography, styled } from "@mui/material"

import Form from "components/Refinance/Sign/Form"

type Props = {
  onSign: () => void
}

const RefinanceConsentTerms = ({ onSign }: Props) => {
  const { t } = useTranslation()

  return (
    <Content>
      <Title variant="h5">{t("features.refinance.terms.title")}</Title>
      <Description variant="h6">
        {t("features.refinance.terms.description")}
      </Description>
      <Form
        initialValues={{
          plusplus: false,
          freshfinance: false,
          advertisement: false,
        }}
        onSubmit={() => onSign()}
      />
    </Content>
  )
}

export default RefinanceConsentTerms

const Content = styled(Box)(() => ({
  margin: "0 auto",
  maxWidth: "750px",
}))

const Title = styled(Typography)(() => ({
  margin: "15px 0 5px 0",
}))

const Description = styled(Typography)(() => ({
  margin: "0 0 15px 0",
}))
